module.exports = __webpack_public_path__ + "img/eye-dropper.45069816.svg";